import { axiosInstance } from "./axiosInstance";

export const aiAssistantService = {
  // Ask a question to the AI assistant
  askQuestion: async (question) => {
    const { data } = await axiosInstance.post("/assistant/ask", { question });
    return data;
  },

  // Reset conversation context
  resetContext: async () => {
    const { data } = await axiosInstance.post("/assistant/reset-context");
    return data;
  },

  // Get conversation history
  getHistory: async () => {
    const { data } = await axiosInstance.get("/assistant/history");
    return data;
  },

  // Get paginated conversation history
  getPaginatedHistory: async (page = 0, size = 20) => {
    const { data } = await axiosInstance.get("/assistant/history/paginated", {
      params: { page, size }
    });
    return data;
  },

  // Delete a specific conversation
  deleteConversation: async (conversationId) => {
    const { data } = await axiosInstance.delete(`/assistant/history/${conversationId}`);
    return data;
  },

  // Delete all conversation history
  deleteAllHistory: async () => {
    const { data } = await axiosInstance.delete("/assistant/history/all");
    return data;
  }
};